module.exports = __webpack_public_path__ + "images/emoji/file_folder.3108799b667b430d32cd.png";